import { render, staticRenderFns } from "./OptixLabAnalyzer.vue?vue&type=template&id=16693b4b&scoped=true"
import script from "./OptixLabAnalyzer.vue?vue&type=script&lang=js"
export * from "./OptixLabAnalyzer.vue?vue&type=script&lang=js"
import style0 from "./OptixLabAnalyzer.vue?vue&type=style&index=0&id=16693b4b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16693b4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16693b4b')) {
      api.createRecord('16693b4b', component.options)
    } else {
      api.reload('16693b4b', component.options)
    }
    module.hot.accept("./OptixLabAnalyzer.vue?vue&type=template&id=16693b4b&scoped=true", function () {
      api.rerender('16693b4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/OptixLabAnalyzer.vue"
export default component.exports